import Vue from 'vue'
import Router from 'vue-router'
import Error from 'views/error'
import EquipmentMain from 'views/equipment/main'
import EquipmentIndex from 'views/equipment'
import EquipmentSuggestion from 'views/equipment/suggestion'
import MeMain from 'views/me/main'
import MyReward from 'views/me/reward'
import MyRewardList from 'views/me/reward-list'
import MyRewardDetail from 'views/me/reward-detail'
import Account from 'views/me/account'
import Withdraw from 'views/me/withdraw'
import WithdrawStatus from 'views/me/withdraw-status'
import Download from 'views/download'
const EquipmentSpecification = () => import('views/equipment/specification')
const EquipmentManual = () => import('views/equipment/manual')
const EquipmentQuickStart = () => import('views/equipment/quick-start')
const EquipmentASSPolicy = () => import('views/equipment/ass-policy')
// import zhLocale from '@/lang/zh'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/error',
      name: 'Error',
      component: Error,
      meta: {
        title: 'Error'
      }
    },
    {
      path: '/',
      redirect: '/equipment'
    },
    {
      path: '/equipment',
      component: EquipmentMain,
      children: [
        {
          path: '/',
          redirect: 'index'
        },
        {
          path: 'index',
          name: 'EquipmentIndex',
          component: EquipmentIndex
        },
        {
          path: 'suggestion',
          name: 'EquipmentSuggestion',
          component: EquipmentSuggestion
        },
        {
          path: 'specification',
          name: 'EquipmentSpecification',
          component: EquipmentSpecification
        },
        {
          path: 'manual',
          name: 'EquipmentManual',
          component: EquipmentManual
        },
        {
          path: 'quick-start',
          name: 'EquipmentQuickStart',
          component: EquipmentQuickStart
        },
        {
          path: 'ass-policy',
          name: 'EquipmentASSPolicy',
          component: EquipmentASSPolicy
        }
      ]
    },
    {
      path: '/me',
      component: MeMain,
      children: [
        {
          path: '/',
          redirect: 'reward'
        },
        {
          path: 'reward',
          name: 'MyReward',
          component: MyReward
        },
        {
          path: 'reward-list',
          name: 'MyRewardList',
          component: MyRewardList
        },
        {
          path: 'reward-detail/:orderId',
          name: 'MyRewardDetail',
          component: MyRewardDetail
        },
        {
          path: 'account',
          name: 'Account',
          component: Account
        },
        {
          path: 'withdraw',
          name: 'Withdraw',
          component: Withdraw
        },
        {
          path: 'withdraw-status',
          name: 'WithdrawStatus',
          component: WithdrawStatus
        }
      ]
    },
    {
      path: '/download',
      name: 'Download',
      component: Download
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js